module.exports = __webpack_public_path__ + "static/img/pdf.7c09d89f.png";